import React, { useRef } from 'react'
import { VscBriefcase } from "react-icons/vsc";
import { FiFileText } from "react-icons/fi";
import { BiSupport } from "react-icons/bi";
import { LuAward } from "react-icons/lu";
import { motion, useInView } from 'framer-motion';

const About = () => {


    const boxVariant = {
        initial : {
          // x : width > 0 ? -100 : "0",
          x : 100,
          opacity : 0
        },
        animate : {
          opacity : 1,
          x: 0,
          transition : {
            duration: 0.5,
            staggerChildren : 0.7,
            when : "beforeChildren",
            delay:1,
          } , 
        }
      }
  
      // const transition = { duration: 0.5, ease: "easeInOut", type : "tween" };

      const boxChild = {
        initial : {
          // x : width > 0 ? -100 : "0",
          x : 100,
          opacity : 0
        },
        animate : {
          opacity : 1,
          x: 0,
          transition : {
            duration: 0.5,
            staggerChildren : 0.7,
            when : "beforeChildren",
          } , 
        }
      }
      
      
      
      
      const aboutVariant = {
        initial : {
            // x : width > 0 ? -100 : "0",
            x : -100,
            opacity : 0
          },
          animate : {
            opacity : 1,
            x: 0,
            transition : {
              duration: 0.5,
              staggerChildren : 0.7,
              when : "beforeChildren",
            } , 
        }
    }

    const leftVar = {
        initial : {
            x : -100,
            opacity : 0
          },
          animate : {
            opacity : 1,
            x: 0,
            transition : {
              duration: 0.5,
              
            //   staggerChildren : 0.7
            } , 
        }
    }
   
    const rightVar = {
        initial : {
            x : 100,
            opacity : 0
          },
          animate : {
            opacity : 1,
            x: 0,
            transition : {
              duration: 0.5,
              
            } , 
        }
    }



      const paragraphRef = useRef(null);
      const isInView = useInView(paragraphRef, { once: true });
    

      const paragraphText2 = `I'm Sakariyau Abdulateef, a software engineer with 5+ years building systems where correctness costs money — multi-currency payment ledgers, multi-tenant SaaS platforms, and continental-scale evaluation systems — alongside 14 published mobile applications on Google Play and the App Store.

My core stack is JavaScript/TypeScript across Node.js (Express, NestJS) and React Native, with production work in C#/.NET microservices and working proficiency in Python/Django and PHP/Laravel.

I've processed ₦50M+ across multi-currency wallets with zero balance inconsistencies, cut API latency from ~800ms to under 200ms at 10K+ daily active users, and run self-directed security audits that caught and fixed a cross-tenant IDOR before it reached production.

I care deeply about clean architecture, correctness under load, and developer experience — and I enjoy turning complex, high-stakes requirements into simple, reliable software.`

      





  return (
    <motion.div className='about-section py-4' id='about'>
        <motion.div className="container2">
            <div className="sec-header mb-4 text-center ">
                <h2 className="text-bold">About Me</h2>
                <p className="about-text text-muted">My Introduction</p>
            </div>

            <motion.div variants={aboutVariant} initial="initial" animate="animate" className="row m-0 ">
                <motion.div variants={leftVar} className="col-lg-6 px-4 py-lg-2">
                    <div className="about-img border">
                        <img src="../../Images/portfolio2.jpeg" className='img-fluid' alt="" />
                    </div>
                </motion.div>
                <motion.div  variants={rightVar} className="col-lg-6 p-lg-2 mt-3 mt-lg-0">
                    <motion.div 
                      className="grid gap-2 gap-lg-3 m-0"
                      variants={boxVariant}
                      initial="initial"
                      whileInView="animate"
                    >
                        <motion.div variants={boxChild} className="box rounded shadow-sm bg-white text-center d-flex flex-column align-items-center justify-content-center gap-2 p-2 p-lg-3">
                            <LuAward size={24} />
                            <h6 className='text-bold'>Experience</h6>
                            <small className='text-muted'>5+ Years Building</small>
                        </motion.div>
                        <motion.div variants={boxChild} className="box rounded shadow-sm bg-white text-center d-flex flex-column align-items-center justify-content-center gap-2 p-2 p-lg-3">
                            <VscBriefcase size={24} />
                            <h6 className='text-bold'>Platforms Shipped</h6>
                            <small className='text-muted'>20+ Production Systems</small>
                        </motion.div>
                        <motion.div variants={boxChild} className="box rounded shadow-sm bg-white text-center d-flex flex-column align-items-center justify-content-center gap-2 p-2 p-lg-3">
                            <BiSupport size={24} />
                            <h6 className='text-bold'>Mobile Apps</h6>
                            <small className='text-muted'>14 Published</small>
                        </motion.div>
                    </motion.div>
                    <motion.div className="me my-4">
                      

                          <div ref={paragraphRef}>
                                {isInView && (
                                  <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 1 }}
                                    style={{ 
                                      whiteSpace: "pre-wrap", 
                                      fontSize: "14px",
                                      textAlign: "justify",
                                      hyphens: "auto",
                                      WebkitHyphens: "auto",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {paragraphText2.split("").map((char, index) => (
                                      <motion.span
                                        key={index}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{
                                          delay: index * 0.008, // Adjust typing speed
                                        }}
                                      >
                                        {char}
                                      </motion.span>
                                    ))}
                                  </motion.div>
                                )}
                              </div>

                            
                    </motion.div>
                    {isInView && (
                    <motion.a
                       href="../../Images/Abdul-Lateef Resume.pdf"
                       className="works"
                     target="_blank" // Open in new tab
                      rel="noopener noreferrer" // Security best practice
                       initial={{ x: 100, opacity: 0 }}
                       animate={{ x: 0, opacity: 1 }}
                       transition={{
                         delay: paragraphText2.length * 0.008 + 1, // Start after text animation
                         duration: 0.5,}}
                      >
                        <p>Download CV</p>
                        <FiFileText size={20} />
                    </motion.a>)}
                </motion.div>
            </motion.div>
        </motion.div>
    </motion.div>
  )
}

export default About



